import { CustomerPaystackCard } from "../model/customer/customer";
import { InitateCardPayment, InitiateCardPaymentResponse } from "../model/payments/payments";
import { TransactionStatus } from "../model/transaction";
import { apiSlice } from "../stores/base/api-slice";
const paystackEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		authorizeCardTransaction: builder.mutation<InitiateCardPaymentResponse, InitateCardPayment>({
			query: body => ({
				url: `/pay-stack/initiate-card-transaction`,
				method: "POST",
				body,
			}),
		}),
		chargeInitalDepositWithCard: builder.mutation<string, any>({
			query: orderId => ({
				url: `/pay-stack/charge/deposit/${orderId}`,
				method: "POST",
			}),
		}),
		chargeMonthlyRepaymentWithCard: builder.mutation<string, any>({
			query: orderId => ({
				url: `/pay-stack/charge/${orderId}`,
				method: "POST",
			}),
		}),
		chargeRemainderWithCard: builder.mutation<string, any>({
			query: orderId => ({
				url: `/pay-stack/charge/remainder/${orderId}`,
				method: "POST",
			}),
		}),
		chargeAnyAmountWithCard: builder.mutation<string, any>({
			query: body => ({
				url: `/pay-stack/charge/arbitrary`,
				method: "POST",
				body,
			}),
		}),
		verifyPaystackPayment: builder.query<{ reference: string; status: TransactionStatus }, string>({
			query: reference => ({
				url: `/pay-stack/verify-card-transaction/${reference}`,
				method: "GET",
			}),
		}),
		getCards: builder.query<CustomerPaystackCard[], void>({
			providesTags: ["CustomerCards"],
			query: () => ({
				url: "/pay-stack/cards",
				method: "GET",
			}),
		}),
		verifyPendingCards: builder.mutation<void, void>({
			query: () => ({
				url: "/pay-stack/verify-pending-card-statuses",
				method: "POST",
			}),
			invalidatesTags: ["CustomerCards"],
		}),
	}),
});
export const {
	useAuthorizeCardTransactionMutation,
	useChargeInitalDepositWithCardMutation,
	useChargeMonthlyRepaymentWithCardMutation,
	useChargeAnyAmountWithCardMutation,
	useChargeRemainderWithCardMutation,
	useLazyVerifyPaystackPaymentQuery,
	useLazyGetCardsQuery,
	useVerifyPendingCardsMutation,
} = paystackEndpoints;
